import { SSOClient } from "@/shared/infra/sso";
export var makeAuthClient = function () { return new SSOClient(); };
